import React from 'react';
import Translation from '../translation/translation';

function FSHomePageLightBoxHeader() {
    return (
        <div className="fs-home-page-light-box__header fs-home-page-light-box-header">
            <Translation
                translationKey="fs-home-page-light-box-header"
                className="fs-home-page-light-box-header__headline"
            />
        </div>
    );
}

export { FSHomePageLightBoxHeader };
